<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="(meeting.safety_meeting_id ? 'Edit Safety Meeting: ' + meeting.safety_meeting_id : 'New Safety Meeting') + ' :: MeritEHS'"/>

            <h4 class="py-2 mb-2">
                <ol class="breadcrumb font-weight-light m-0 d-block d-md-inline-block">
                    <li class="breadcrumb-item font-weight-light d-block d-md-inline-block">
                        <router-link :to="`/safety-meetings`">
                            <i class="fa fa-life-ring"></i> Safety Meetings
                        </router-link>
                    </li>
                    <template v-if="meeting.safety_meeting_id">
                        <li class="breadcrumb-item font-weight-light d-block d-md-inline-block mt-md-0 mt-2">
                            <router-link :to="`/safety-meetings/view/${meeting.safety_meeting_id}`">
                                Meeting on {{ meeting.meeting_date | moment("MM/DD/YYYY") }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active d-block d-md-inline-block mt-md-0 mt-2"><i class="fa fa-edit"></i> Edit</li>
                    </template>
                    <template v-else>
                        <li class="breadcrumb-item active d-block d-md-inline-block mt-md-0 mt-2"><i class="fa fa-plus"></i> New</li>
                    </template>
                    <li class="ml-3 d-none d-md-inline-block">
                        <button type="button" class="btn btn-sm btn-success" v-on:click="saveSafetyMeeting(this)" :disabled="saving">
                            <span v-if="meeting.safety_meeting_id">Update</span>
                            <span v-else>Create</span>
                            Safety Meeting
                        </button>
                    </li>
                </ol>
            </h4>

            <div class="d-block d-md-none mt-3 mb-3">
                <button type="button" class="btn btn-sm btn-success" v-on:click="saveSafetyMeeting(this)" :disabled="saving">
                    <span v-if="meeting.safety_meeting_id">Update</span>
                    <span v-else>Create</span>
                    Safety Meeting
                </button>
            </div>

            <div class="row mt-4">
                <div class="col-xl-8 col-lg-10 col-md-12">
                    <div class="card mb-3">
                        <div class="card-body">

                            <div class="row form-group">
                                <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">
                                    Status: <i class="fa fa-sm fa-asterisk text-danger"></i>
                                </label>
                                <div class="col-md-8 col-sm-12">
                                    <select v-model="meeting.meeting_status" class="form-control">
                                        <option value="Open">Open</option>
                                        <option value="Closed">Closed</option>
                                    </select>
                                </div>
                            </div>

                            <div class="row form-group">
                                <label :class="{'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.meeting_title}">Meeting Title:</label>
                                <div class="col-md-8 col-sm-12">

                                    <b-form-input v-model="meeting.meeting_title" :class="{'is-invalid': errors.meeting_title}" placeholder="Enter a Meeting Title (Optional)"></b-form-input>

                                    <span v-if="errors.meeting_title" class="text-danger">
                                        <span v-for="error in errors.meeting_title">{{ error }}</span>
                                    </span>
                                </div>
                            </div>

                            <div class="row form-group">
                                <label :class="{ 'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.JobsiteId}">
                                    Jobsite: <i class="fa fa-sm fa-asterisk text-danger"></i>
                                </label>
                                <div class="col-md-8 col-sm-12">
                                    <jobsite-select :selectedValues="SiteSelectedValues" v-on:vselected="onJobSiteSelectUpdate" :hasError="errors.JobsiteId ? true : false"></jobsite-select>
                                    <span v-if="errors.JobsiteId" class="text-danger">
                                        <span v-for="error in errors.JobsiteId">{{ error }}</span>
                                    </span>
                                </div>
                            </div>

                            <div class="row form-group">
                                <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">
                                    Date: <i class="fa fa-sm fa-asterisk text-danger"></i>
                                </label>
                                <div class="col-md-8 col-sm-12">
                                    <date-picker v-model="meeting.meeting_date" @dp-change="datePickerChanged" :config="options"></date-picker>

                                    <span v-if="errors.meeting_date" class="text-danger">
                                        <span v-for="error in errors.meeting_date">{{ error }}</span>
                                    </span>
                                </div>
                            </div>

                            <div class="row form-group">
                                <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right"></label>
                                <div class="col-md-8 col-sm-12 pt-sm-2 pt-0">
                                    <b-form-checkbox v-model="meeting.auto_add_attendees" :value="1" :unchecked-value="0" plain>
                                        Automatically Add Employees As Attendees <i class="fa fa-question-circle" title="If checked, MeritEHS will automatically add employees as meeting attendees when they click the Public URL."></i>
                                    </b-form-checkbox>
                                </div>
                            </div>

                            <div class="row form-group" v-if="meeting.meeting_key || meeting.generate_key">
                                <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right"></label>
                                <div class="col-md-8 col-sm-12 pt-sm-2 pt-0">
                                    <b-form-checkbox v-model="is_sub_only" :value="true" :unchecked-value="false" plain>
                                        Is Subcontractor
                                    </b-form-checkbox>
                                </div>
                            </div>

                            <div class="row form-group" v-show="is_sub_only">

                                <label :class="{'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.subcontractor_id}">Subcontractor:</label>

                                <div class="col-md-8 col-sm-12">
                                    <div v-if="subcontractors.length == 0" class="alert alert-warning">
                                        <p style="color:red;">You do not have any existing "Approved" or "Contionally Approved" Subcontractors.<br> <router-link :to="`/subcontractors`"> Click here </router-link> to check list of Subcontractors </p>
                                    </div>

                                    <div v-else>
                                        <b-form-select v-model="meeting.subcontractor_id" :options="subOptions" :class="{'is-invalid': errors.subcontractor_id}"></b-form-select>

                                        <span v-if="errors.subcontractor_id" class="text-danger">
                                            <span v-for="error in errors.subcontractor_id">{{ error }}</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card mb-3" v-if="!meeting.meeting_key">
                        <div class="card-header">Generate Public URL</div>
                        <div class="card-body">
                            <div class="form-group">
                                <b-form-checkbox v-model="meeting.generate_key" :value="true" :unchecked-value="false" plain>
                                    Generate a Public URL for Employees to use
                                </b-form-checkbox>
                            </div>
                            <div class="alert alert-warning">
                                Generating a public url will allow the contents of this safety meeting to be access by any employee with the URL. Employees will be prompted to enter their ID, Email, or Phone to log their access of the meeting. <strong>Note:</strong> The URL key uses encryption like generation making it impossible for someone to guess. Only those with the URL will be able to access this information.
                            </div>
                        </div>
                    </div>

                    <div class="card mb-3">
                        <div class="card-header">Attendees</div>
                        <div class="card-body">
                            <div class="row form-group">
                                <label class="col-lg-2 col-md-3 col-form-label text-sm-right">Employees:</label>
                                <div class="col-md-8 col-sm-12">
                                    <employee-select ref="newMemberEmployee" @vselected="safetyMemberEmployee"></employee-select>
                                    <hr/>

                                    <ul class="list-unstyled">
                                        <li v-for="person in employees">
                                            <button class="btn btn-xs btn-link text-danger" title="Remove Employee" v-on:click="deleteAttendee(person.EmployeeId)" v-if="person.id" :disabled="deleting_employee">
                                                <i class="fa fa-remove"></i>
                                            </button>
                                            <button class="btn btn-xs btn-link text-danger" title="Remove Employee" v-on:click="removeAttendee(person.EmployeeId)" v-else>
                                                <i class="fa fa-remove"></i>
                                            </button>
                                            <router-link :to="`/employees/view/${person.EmployeeId}`">
                                                {{ person.FirstName }} {{ person.LastName }} <template v-if="person.EmployeeNumber">- {{ person.EmployeeNumber }}</template>
                                            </router-link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card mb-3">
                        <div class="card-header">Meeting Notes</div>
                        <div class="card-body">
                            <vue-editor v-model="meeting.meeting_notes" :editor-toolbar="this.$root.customVueEditorToolbar"></vue-editor>
                        </div>
                    </div>

                    <div class="card mb-3">
                        <div class="card-header">Meeting Files</div>
                        <div class="card-body">
                            <div class="form-group row">
                                <label class="col-lg-2 col-md-3 col-form-label text-sm-right">Files:</label>
                                <div class="col-md-8 col-sm-12">

                                    <b-form-file v-model="files" multiple placeholder="Select Files or Drag & Drop Them Here"></b-form-file>

                                    <span v-if="errors.files" class="text-danger">
                                        <span v-for="error in errors.files">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr/>
            <button type="button" class="btn btn-success" v-on:click="saveSafetyMeeting(this)" :disabled="saving">
                <span v-if="meeting.safety_meeting_id">Update</span>
                <span v-else>Create</span>
                Safety Meeting
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                saving: false,
                is_sub_only: false,
                deleting_employee: false,
                safety_meeting_id: this.$route.params.id,
                meeting: {
                    generate_key: false,
                },
                subcontractors: [],
                employees: [],
                files: [],
                errors: {},
                options: {
                    format: 'MM/DD/YYYY',
                    date: ""
                },
                new_safety_member: {
                    member_type: null,
                },
            }
        },

        computed: {
            //User Setter
            userSelectValues(){
                //Check for null
                if(!this.meeting.UserId || this.meeting.UserId == null)
                {
                    return null;
                }

                //Send it
                return { UserId: this.meeting.UserId, FirstName: this.meeting.FirstName, LastName: this.meeting.LastName};
            },

            SiteSelectedValues(){
                //check for null
                if(!this.meeting.JobsiteId || this.meeting.JobsiteId == null)
                {
                    //Check the store
                    if(this.$store.state.user.jobsite)
                    {
                        //Set the jobsite
                        var jobsite = this.$store.state.user.jobsite;

                        //Set the Safety Meeting jobsite
                        this.meeting.JobsiteId = jobsite.JobsiteId;

                        //Send it
                        return {JobsiteId: jobsite.JobsiteId, JobsiteNumber: jobsite.JobsiteNumber, JobsiteName: jobsite.JobsiteName};
                    }

                    //Send it
                    return null;
                }

                //Send it
                return {JobsiteId: this.meeting.JobsiteId, JobsiteNumber: this.meeting.JobsiteNumber, JobsiteName: this.meeting.JobsiteName};
            },

            subOptions(){
                //Setup
                var options = [{value: null, text: '-- Select a Subcontractor --'}];

                //Build it
                for(var i = 0; i < this.subcontractors.length; i++)
                {
                    //Append
                    options.push({value: this.subcontractors[i].subcontractor_id, text: this.subcontractors[i].subcontractor_name});
                }

                //Send it
                return options;
            },
        },

        watch: {
            is_sub_only(newVal, oldVal){
                //Check if we unchecked it
                if(newVal === false)
                {
                    this.meeting.subcontractor_id = null;
                }
            },

            'meeting.auto_add_attendees'(newVal, oldVal){
                //Check value
                if(newVal == 1)
                {
                    //Check the Generate Public Url
                    this.meeting.generate_key = true;
                }
            },
        },

        methods: {

            getSafetyMeeting() {
                //Get the data
                this.$http
                    .get('safety-meetings/edit' + (this.safety_meeting_id ? '/' + this.safety_meeting_id : ''))
                    .then(response => {
                        //Set all the data
                        this.meeting = response.data.meeting;
                        this.subcontractors = response.data.subcontractors;
                        this.employees = response.data.employees;
                        this.options.date = this.meeting.meeting_date;

                        //Setters
                        //this.is_sub_only = this.meeting.subcontractor_id ? true : false;
                        this.is_sub_only = false;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            saveSafetyMeeting() {
                //SHow loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Setters
                this.meeting.is_sub_only = this.is_sub_only;
                this.meeting.employees = this.employees;

                //Send it
                this.$http
                .postWithFiles('safety-meetings/edit' + (this.safety_meeting_id ? '/' + this.safety_meeting_id : ''), this.meeting, this.files)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Safety Meeting Saved');

                    //Return to main list?
                    this.$router.push('/safety-meetings/view/' + response.data.safety_meeting_id);
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            },

            onJobSiteSelectUpdate (jobsite) {
              //Check for null
                if(jobsite == null)
                {
                    //Stop
                    this.meeting.JobsiteId = null;
                    return;
                }

                //Send the value
                this.meeting.JobsiteId = jobsite.JobsiteId;
                //this.meeting.JobsiteName = jobsite.JobsiteName;
                //this.meeting.JobsiteNumber = jobsite.JobsiteNumber;
            },

            onUserSelectUpdate (user)
            {
                //Check for null
                if(user == null)
                {
                    this.meeting.UserId = null
                    return;
                }

                //Set it
                this.meeting.UserId = user.UserId;
            },

            datePickerChanged ( data ) {
                // Stringify datePicked
                var dateParts = data.target.value.split("/");
                this.meeting.meeting_date = dateParts[2]+'-'+dateParts[0]+'-'+dateParts[1];
            },

            safetyMemberEmployee(employee){
                //Check for null
                if(employee == null)
                {
                    //Set Focus
                    this.$refs.newMemberEmployee.setFocus();

                    //Stop Here
                    return;
                }

                //Loop
                for(var i in this.employees)
                {
                    //Check type and id
                    if(this.employees[i].EmployeeId == employee.EmployeeId)
                    {
                        //Alert the user
                        this.$toastr.warning('This employee is already an attendee');

                        //Send it
                        this.$refs.newMemberEmployee.clearInput();

                        //Set Focus
                        this.$refs.newMemberEmployee.setFocus();

                        //Stop
                        return;
                    }
                }

                //Setters
                this.employees.push(employee);

                //Send it
                this.$refs.newMemberEmployee.clearInput();

                //Set Focus
                this.$refs.newMemberEmployee.setFocus();

                //Without this, it won't re-render the input names
                //this.$forceUpdate();
            },

            removeAttendee(EmployeeId){
                //Loop
                for(var i in this.employees)
                {
                    //Check type and id
                    if(this.employees[i].EmployeeId == EmployeeId)
                    {
                        this.employees.splice(i, 1);
                    }
                }
            },

            deleteAttendee(EmployeeId){
                //Send it and show loading
                this.deleting_employee = true;

                //Send it
                this.$http
                    .post('/safety-meetings/delete-attendee/'+this.meeting.safety_meeting_id + '/' + EmployeeId)
                    .then(response => {
                        //Alert the user?
                        this.$toastr.success('Attendee Deleted');

                        //Push Or Update
                        for (var i = this.employees.length - 1; i >= 0; i--)
                        {
                            //Check All IDs
                            if(this.employees[i].EmployeeId == EmployeeId)
                            {
                                //Splice it in
                                this.employees.splice(i, 1);

                                //Stop
                                return;
                            }
                        }
                    })
                    .catch(error => {
                        //Check for error
                        if (error.response.status === 422)
                        {
                            //Display validation errors
                            this.errors = error.response.data;
                        }
                    })
                    .then(response => {
                        //SHow loading
                        this.deleting_employee = false;

                        //Reset the errors
                        this.errors = {};
                    });
            },
        },

        mounted() {
            //Get the Safety Meeting
            this.getSafetyMeeting();
        }
    }
</script>
